import {
  DEFAULT_DELIVERY_METHODS,
} from "./siteSettingsApi";

export const DELIVERY_METHOD_TYPES = Object.freeze({
  NOVA_POSHTA_BRANCH: "branch",
  NOVA_POSHTA_LOCKER: "locker",
  NOVA_POSHTA_COURIER: "courier-nova-poshta",
  KYIV_COURIER: "courier-kyiv",
});

export const DELIVERY_METHOD_LABELS = Object.freeze({
  [DELIVERY_METHOD_TYPES.NOVA_POSHTA_BRANCH]: "У відділення Нової пошти",
  [DELIVERY_METHOD_TYPES.NOVA_POSHTA_LOCKER]: "У поштомат Нової пошти",
  [DELIVERY_METHOD_TYPES.NOVA_POSHTA_COURIER]: "Кур'єром Нової пошти",
  [DELIVERY_METHOD_TYPES.KYIV_COURIER]:
    "Кур'єром в межах міста Києва",
});

export const CHECKOUT_DELIVERY_METHOD_OPTIONS = Object.freeze([
  {
    type: DELIVERY_METHOD_TYPES.NOVA_POSHTA_BRANCH,
    settingKey: "novaPoshtaBranch",
    label: DELIVERY_METHOD_LABELS[DELIVERY_METHOD_TYPES.NOVA_POSHTA_BRANCH],
    value: DELIVERY_METHOD_LABELS[DELIVERY_METHOD_TYPES.NOVA_POSHTA_BRANCH],
  },
  {
    type: DELIVERY_METHOD_TYPES.NOVA_POSHTA_LOCKER,
    settingKey: "novaPoshtaLocker",
    label: DELIVERY_METHOD_LABELS[DELIVERY_METHOD_TYPES.NOVA_POSHTA_LOCKER],
    value: DELIVERY_METHOD_LABELS[DELIVERY_METHOD_TYPES.NOVA_POSHTA_LOCKER],
  },
  {
    type: DELIVERY_METHOD_TYPES.NOVA_POSHTA_COURIER,
    settingKey: "novaPoshtaCourier",
    label: DELIVERY_METHOD_LABELS[DELIVERY_METHOD_TYPES.NOVA_POSHTA_COURIER],
    value: DELIVERY_METHOD_LABELS[DELIVERY_METHOD_TYPES.NOVA_POSHTA_COURIER],
  },
]);

const normalizeMethod = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[’ʼ`]/g, "'")
    .replace(/\s+/g, " ");

const DELIVERY_METHOD_ALIASES = Object.freeze({
  [DELIVERY_METHOD_TYPES.NOVA_POSHTA_BRANCH]:
    DELIVERY_METHOD_TYPES.NOVA_POSHTA_BRANCH,
  [normalizeMethod("У відділення Нової пошти")]:
    DELIVERY_METHOD_TYPES.NOVA_POSHTA_BRANCH,
  [normalizeMethod("У відділення «Нової пошти»")]:
    DELIVERY_METHOD_TYPES.NOVA_POSHTA_BRANCH,
  [normalizeMethod("Самовивіз з відділення Нової пошти")]:
    DELIVERY_METHOD_TYPES.NOVA_POSHTA_BRANCH,

  [DELIVERY_METHOD_TYPES.NOVA_POSHTA_LOCKER]:
    DELIVERY_METHOD_TYPES.NOVA_POSHTA_LOCKER,
  [normalizeMethod("У поштомат Нової пошти")]:
    DELIVERY_METHOD_TYPES.NOVA_POSHTA_LOCKER,
  [normalizeMethod("У поштомат «Нової пошти»")]:
    DELIVERY_METHOD_TYPES.NOVA_POSHTA_LOCKER,

  [DELIVERY_METHOD_TYPES.NOVA_POSHTA_COURIER]:
    DELIVERY_METHOD_TYPES.NOVA_POSHTA_COURIER,
  [normalizeMethod("Кур'єром Нової пошти")]:
    DELIVERY_METHOD_TYPES.NOVA_POSHTA_COURIER,
  [normalizeMethod("Курʼєром Нової пошти")]:
    DELIVERY_METHOD_TYPES.NOVA_POSHTA_COURIER,
  [normalizeMethod("Кур’єром «Нової пошти»")]:
    DELIVERY_METHOD_TYPES.NOVA_POSHTA_COURIER,

  [DELIVERY_METHOD_TYPES.KYIV_COURIER]: DELIVERY_METHOD_TYPES.KYIV_COURIER,
  [normalizeMethod("Кур'єром в межах міста Києва")]:
    DELIVERY_METHOD_TYPES.KYIV_COURIER,
  [normalizeMethod("Кур’єром у межах міста Київ")]:
    DELIVERY_METHOD_TYPES.KYIV_COURIER,
  [normalizeMethod("Курʼєром по Києву")]: DELIVERY_METHOD_TYPES.KYIV_COURIER,
});

export const getDeliveryMethodType = (method) =>
  DELIVERY_METHOD_ALIASES[normalizeMethod(method)] || "";

export const getDeliveryMethodValue = (method) => {
  const type = getDeliveryMethodType(method);
  return type ? DELIVERY_METHOD_LABELS[type] : method || "";
};

export const getDeliveryMethodLabel = (method) =>
  getDeliveryMethodValue(method) || "Невідомий спосіб доставки";

export const isNovaPoshtaBranchDelivery = (method) =>
  getDeliveryMethodType(method) === DELIVERY_METHOD_TYPES.NOVA_POSHTA_BRANCH;

export const isNovaPoshtaLockerDelivery = (method) =>
  getDeliveryMethodType(method) === DELIVERY_METHOD_TYPES.NOVA_POSHTA_LOCKER;

export const isBranchDelivery = (method) =>
  isNovaPoshtaBranchDelivery(method) || isNovaPoshtaLockerDelivery(method);

export const isNovaPoshtaCourierDelivery = (method) =>
  getDeliveryMethodType(method) ===
  DELIVERY_METHOD_TYPES.NOVA_POSHTA_COURIER;

export const isKyivCourierDelivery = (method) =>
  getDeliveryMethodType(method) === DELIVERY_METHOD_TYPES.KYIV_COURIER;

export const isCourierDelivery = (method) =>
  isNovaPoshtaCourierDelivery(method) || isKyivCourierDelivery(method);

export { DEFAULT_DELIVERY_METHODS };
